module.exports = __webpack_public_path__ + "assets/cynergy_app_half.57abc140.svg";